import React, { Component } from 'react';
import Spacer, { Label, NumericInput} from 'app/components/Basics';
import { Card } from '@ecosystem/ui-lib/core/components/Card';
import { Input as EcoInput } from '@ecosystem/ui-lib/core/components/Input';
import { CardOptionsAlternative } from '../TabOptions/TabOptionsComponent';
import './TabInputComponent.scss';
import {QuestionFormContext} from '../../QuestionContext'
import { Checkbox } from '@ecosystem/ui-lib/core/components/Checkbox';
import { GetLanguageTexts, addMissingLanguageTexts } from '../../QuestionTextHelper';

class TabInputText extends Component {

    constructor(props){
        super(props);
        this.state = {}
    }

    handleMaxLengthInput(event) {
        var selectedQuestion = this.context.selectedQuestion;
        selectedQuestion.openMax = parseInt(event.target.value);
        this.context.updateSelectedQuestion(selectedQuestion);
    }

    isOpenTextOptional() {
        return this.context.selectedQuestion.openOptional === 1;
    }

    openTextOptionalHandler = event => {    
        var selectedQuestion = this.context.selectedQuestion;
        selectedQuestion.openOptional = event.target.checked ? 1 : 0;
        this.context.updateSelectedQuestion(selectedQuestion);
    }

    OptionalTextHandler = event => {            
        GetLanguageTexts(this.context.selectedQuestion.texts, this.context.selectedLanguageCode).openOptional = event.target.value;
        this.context.updateSelectedQuestion(this.context.selectedQuestion);
    }    
    
    render() {
        return (
            <div className="TabInputComponent TabInputTextComponent content-box">
                <Card>
                    <div className="form-row">
                        <div className="optionalTextRow form-row-left">
                            <Checkbox disabled={!this.context.canChangeData} label="Optional" checked={this.isOpenTextOptional()} onChange={this.openTextOptionalHandler} />
                            <Spacer width={50} />                           
                            <EcoInput disabled={!this.context.canChangeData} label="Optional text" id="optionalText" name="optionalText" placeholder="- optinal text -" 
                            value={GetLanguageTexts(this.context.selectedQuestion.texts, this.context.selectedLanguageCode).openOptional} 
                            onChange={this.OptionalTextHandler}                            
                            ></EcoInput>
                        </div>                        
                    </div>  
                </Card>               
            </div>
        );
    }
}

class TabInputNumeric extends Component {

    constructor(props){
        super(props);
    }

	getValidationError(field) { 		
		if (!this.props.errors || this.props.errors.length === 0) {			
			return "";
		}		
		var errorText = this.props.errors.find(e => e.field === field);		
		return errorText ? errorText.errorMessage : "";
	}

	numericMinHandler = event => {
        var selectedQuestion = this.context.selectedQuestion;
        selectedQuestion.numericMin = event.target.value !== '' ? parseInt(event.target.value) : '';
        this.context.updateSelectedQuestion(selectedQuestion);
    }
	
	numericMaxHandler = event => {		
        var selectedQuestion = this.context.selectedQuestion;
        selectedQuestion.numericMax = event.target.value !== '' ? parseInt(event.target.value) : '';
        this.context.updateSelectedQuestion(selectedQuestion);
    }
	
	numericDecimalMaxHandler = event => {		
        var selectedQuestion = this.context.selectedQuestion;
        selectedQuestion.numericDecimalMax = event.target.value !== '' ? parseInt(event.target.value) : null;
        this.context.updateSelectedQuestion(selectedQuestion);
    }

	numericSuffixHandler = event => {		
        var selectedQuestion = this.context.selectedQuestion;
        GetLanguageTexts(this.context.selectedQuestion.texts, this.context.selectedLanguageCode).numericSuffix = event.target.value;        
        this.context.updateSelectedQuestion(selectedQuestion);
    }

    render() {
	
        return (
            <div className="TabInputComponent TabInputNumericComponent content-box">
                <Card>
                    <div className="form-row">
                        <div className="form-row-left">
                            <div className={`field-min-value ${this.getValidationError("numericMin") ? "error" : ""}`}>
                                <Label>Min. Value</Label>
                                <NumericInput disabled={!this.context.canChangeData} value={this.context.selectedQuestion.numericMin} onChange={this.numericMinHandler.bind(this)}></NumericInput>
								<span className={`error-container`}>{this.getValidationError("numericMin")}</span>
                            </div>
                            <div className={`field-max-value ${this.getValidationError("numericMax") ? "error" : ""}`}>
                                <Label>Max. Value</Label>
                                <NumericInput disabled={!this.context.canChangeData} value={this.context.selectedQuestion.numericMax} onChange={this.numericMaxHandler.bind(this)}></NumericInput>
								<span className={`error-container`}>{this.getValidationError("numericMax")}</span>
                            </div>

							<div className={`field-max-decimal-digits`}>
                                <Label>Max. Decimal Digits</Label>
                                <NumericInput disabled={!this.context.canChangeData} value={this.context.selectedQuestion.numericDecimalMax} onChange={this.numericDecimalMaxHandler.bind(this)}></NumericInput>								
                            </div>

							<div className={`field-sufix`}>
                                <Label tooltip="A suffix text that will show up next to the numeric text box. Ex.: '%' for a percentage number">Suffix</Label>								
                                <EcoInput disabled={!this.context.canChangeData} id="suffixText" name="suffixText" value={GetLanguageTexts(this.context.selectedQuestion.texts, this.context.selectedLanguageCode).numericSuffix} onChange={this.numericSuffixHandler.bind(this)}></EcoInput>
                            </div>
							
                            {/* <div className="field-placeholder">
                                <Label>Placeholder</Label>
                                <EcoInput id="placeholder" name="placeholder"></EcoInput>
                            </div> */}
                        </div>
                    </div>
                </Card>
                <CardOptionsAlternative errors={this.props.errors}/>
            </div>
        );
    }
}
TabInputText.contextType = QuestionFormContext;
TabInputNumeric.contextType = QuestionFormContext;
export default TabInputText;
export {TabInputText, TabInputNumeric}